// extracted by mini-css-extract-plugin
module.exports = {"label":"label__2ZjCO","expired":"expired__3ZEGo","active":"active__2kmns","done":"done__2EJcL","automate":"automate__23ACi"};